import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import { Link } from "react-router-dom";
import img1 from "../../assets/img/project/icon1.svg";
import { Close, Exchange, Redirect } from "../../assets/ThemeIcon";
import Button from "../../components/Button";
import DashboardShape1 from "../dashboard/components/DashboardShape1";
import DashboardShape2 from "../dashboard/components/DashboardShape2";
import icon1 from "./icon1.png";
import icon2 from "./icon2.png";
// import img2 from '../../assets/img/project/icon2.svg'
// import img3 from '../../assets/img/project/icon3.svg'

export const data = [
	{
		title: "Standard",
		content: [{}, {}],
	},
	{
		title: "Distribution",
		content: [{}],
	},
	{
		title: "LP",
		content: [{}, {}, {}],
	},
];

const Staking = () => {
	const [initialKey, setInitialKey] = useState(0);
	const [popup, setPopup] = useState(false);
	const [titleText, setTitleText] = useState("Stake");
	const handleChange = (e) => {
		setPopup(true);
		setTitleText("Stake");
	};
	const handleChangeTwo = (e) => {
		setPopup(true);
		setTitleText("Withdraw");
	};
	const [index, setIndex] = useState(1);
	const tab__data = data.map((item) => item);
	const { content } = tab__data[index];

	return (
		<section className="dashboard-section">
			<div className="dashboard-shape">
				<DashboardShape1 />
			</div>
			<div className="dashboard-shape-2">
				<DashboardShape2 />
			</div>
			<div className="container">
				<div className="section-title">
					<h2 className="title">Staking</h2>
				</div>
				<div className="section-header">
					<ul className="tab-menu">
						{tab__data &&
							tab__data.map((item, i) => (
								<li
									key={i}
									onClick={() => setIndex(i)}
									className={index === i ? "active" : ""}
								>
									{item.title}
								</li>
							))}
					</ul>
					{/* <div></div> */}
				</div>
				<div className="__accordion-wrapper">
					<Accordion defaultActiveKey={initialKey}>
						{content.map((item, i) => (
							<Accordion.Item eventKey={i} key={i}>
								<Accordion.Header>
									<div className="exchange-item-earn-grp">
										<div className="item">
											<img className="icon1" src={icon1} alt="" />
											<div className="info">
												<span className="sm-text">Stake</span>
												<h6 className="info-name">YLDY LP</h6>
											</div>
										</div>
										{/* Exchange Icon */}
										<div className="exchange">
											<Exchange />
										</div>
										<div className="item">
											<div className="icon-img">
												<img src={icon2} alt="" />
												<img src={icon1} alt="" />
											</div>
											<div className="info">
												<span className="sm-text">Earn</span>
												<h6 className="info-name">
													ALGO - YLDY LP
												</h6>
											</div>
										</div>
									</div>
									<div className="item">
										<div className="info">
											<span className="sm-text">Est. APR</span>
											<h6 className="info-name">46.6%</h6>
										</div>
									</div>
									<div className="item">
										<div className="info">
											<span className="sm-text">TVL</span>
											<h6 className="info-name">
												2,675,896 HDL/YLDY
												<span className="text-base mx-3">-</span>
												<span className="text-base">
													$123,218 USD
												</span>
											</h6>
										</div>
									</div>
									<div className="item ms-xxl-4">
										<div className="info">
											<span className="sm-text">Ends In</span>
											<h6 className="info-name">53 Days</h6>
										</div>
									</div>
								</Accordion.Header>
								<Accordion.Body>
									<div className="__accordion-body">
										<div className="menus">
											<Link to="#">
												Project website <Redirect />
											</Link>
											<Link to="#">
												View Contract <Redirect />
											</Link>
											<Link to="#">
												Opting <Redirect />
											</Link>
										</div>
										<div className="item-wrapper">
											<div className="item-wrapper-item">
												<div>
													<span className="name">My Stake</span>
													<h4 className="amount">
														100 <br /> YLDY
													</h4>
													<span className="price">$173 USD</span>
												</div>
												<Button
													text="Stake"
													className="w-100"
													onClick={handleChange}
												/>
											</div>
											<div className="item-wrapper-item">
												<div>
													<span className="name">
														My Est. Daily Rewards
													</span>
													<h4 className="amount">
														23 <br /> YLDY
													</h4>
													<span className="price">$52 USD</span>
												</div>
												<Button
													text="Withdraw"
													className="w-100"
													onClick={handleChangeTwo}
												/>
											</div>
											<div className="item-wrapper-item">
												<div>
													<span className="name">
														My Claimable Rewards
													</span>
													<h4 className="amount">
														<div className="d-flex align-items-center justify-content-center">
															<img
																src={icon1}
																alt=""
																className="me-2"
															/>
															<span className="amount-txt">
																0.00..
															</span>
														</div>
														<div className="d-flex align-items-center justify-content-center">
															<img
																src={icon2}
																alt=""
																className="me-2"
															/>
															<span className="amount-txt">
																0.00..
															</span>
														</div>
													</h4>
													<span className="price">$0.00USD</span>
												</div>
												<Button text="Claim" className="w-100" />
											</div>
										</div>
									</div>
								</Accordion.Body>
							</Accordion.Item>
						))}
					</Accordion>
				</div>
			</div>
			<PopupModal
				popup={popup}
				setPopup={setPopup}
				icon={img1}
				name={titleText}
			/>
		</section>
	);
};

export const PopupModal = ({ popup, setPopup, icon, name }) => {
	return (
		<Modal
			show={popup}
			size="lg"
			aria-labelledby="contained-modal-title-vcenter"
			centered
		>
			<Modal.Body>
				<div className="modal-close" onClick={() => setPopup(!popup)}>
					<Close />
				</div>
				<div className="__participate-popup-content">
					<img src={icon} alt="" />
					<h4 className="subtitle">{name}</h4>
					<h4 className="sale">Sale</h4>
					<div className="text">Spendable Algo Balance: 0.01 ALGO</div>
					<form>
						<div className="__input-group">
							<input
								type="text"
								className="form-control"
								placeholder="0.00"
							/>
							<span className="max">Max</span>
						</div>
						<button type="submit" className="btn btn-base w-100">
							{name}
						</button>
					</form>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default Staking;
